import React, { useState } from "react";
import { Field, Mono, PrimaryButton } from "./parts";

/*
 * IN PERSON: WHERE, BEFORE WHEN. Asked for 2026-10-07. At their place the
 * drive decides which times exist, so the page cannot show a time until it
 * knows the address. City is the one required field; the street and a line
 * on getting in are optional.
 *
 * Which choices show is his: a link with ?at=office or ?at=theirs skips the
 * question, the plain link asks it. Away from Israel there is no office.
 */

/** "Gabriel's office · Rothschild 1, Tel Aviv" or the address they gave. */
export function placeLine(location, host = "Gabriel") {
  if (!location) return "";
  return location.mode === "office" ? `${host}'s office · ${location.address}` : location.address;
}

export function mapsHref(location) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.address)}`;
}

/** The Where line on the success and manage pages. */
export function WhereFact({ location, host }) {
  if (!location) return null;
  return (
    <>
      <dt className="bk-mono">Where</dt>
      <dd>
        <a className="bk-meet" href={mapsHref(location)} target="_blank" rel="noreferrer">
          {placeLine(location, host)}
        </a>
        {location.note ? <span className="bk-muted"> · {location.note}</span> : null}
      </dd>
    </>
  );
}

export default function WhereStep({ type, host, forced, initial, busy, error, onSubmit }) {
  const office = type && type.office;
  const [at, setAt] = useState(forced || (initial && initial.at) || (office ? null : "theirs"));
  const [street, setStreet] = useState((initial && initial.street) || "");
  const [city, setCity] = useState((initial && initial.city) || "");
  const [note, setNote] = useState((initial && initial.note) || "");
  const [localError, setLocalError] = useState(null);
  const country = (type && type.country) || "Israel";

  const submit = (e) => {
    e.preventDefault();
    setLocalError(null);
    if (at === "office") return onSubmit({ at: "office" });
    if (!city.trim()) return setLocalError("Please add the city.");
    onSubmit({ at: "theirs", street: street.trim(), city: city.trim(), note: note.trim() });
  };

  return (
    <form className="bk-form bk-where" onSubmit={submit}>
      <Mono>Where are we meeting?</Mono>
      {office && !forced ? (
        <div className="bk-choices" role="radiogroup" aria-label="Where are we meeting?">
          <button type="button" role="radio" aria-checked={at === "office"} className="bk-choice" onClick={() => setAt("office")}>
            At {host}'s office
            <span className="bk-muted bk-where__sub">{office.address}</span>
          </button>
          <button type="button" role="radio" aria-checked={at === "theirs"} className="bk-choice" onClick={() => setAt("theirs")}>
            At your place
            <span className="bk-muted bk-where__sub">I'll come to you, anywhere in {country}</span>
          </button>
        </div>
      ) : at === "office" && office ? (
        <p className="bk-lede">{office.address}</p>
      ) : null}

      {at === "theirs" ? (
        <>
          {forced || !office ? <p className="bk-lede">I'll come to you, anywhere in {country}.</p> : null}
          <Field
            type="text"
            name="street"
            autoComplete="street-address"
            placeholder="Street address (optional)"
            value={street}
            onChange={(e) => setStreet(e.target.value)}
            maxLength={200}
          />
          <Field
            type="text"
            name="city"
            autoComplete="address-level2"
            placeholder="City"
            required
            value={city}
            onChange={(e) => setCity(e.target.value)}
            maxLength={100}
          />
          <Field
            type="text"
            name="where-note"
            placeholder="Floor, company name, how to get in (optional)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            maxLength={300}
          />
        </>
      ) : null}

      {localError || error ? <p className="bk-error">{localError || error}</p> : null}
      {at ? (
        <PrimaryButton type="submit" busy={busy}>
          See times
        </PrimaryButton>
      ) : null}
    </form>
  );
}
